import AutoAwesomeRoundedIcon from '@mui/icons-material/AutoAwesomeRounded'
import { useNls } from '../../../../nls/nlsProvider'
import { Button } from '../../../Common/Button'
import { MobileSheet } from '../MobileSheet'
import { ChatAiHistoryCard } from '../../ChatAiHistoryCard'

type Props = {
  open: boolean
  onClose: () => void
  channelName: string
  onOpenAiMagic?: () => void
  summarySlot?: React.ReactNode
}

export const AiHistorySheet = ({ open, onClose, channelName, onOpenAiMagic, summarySlot }: Props) => {
  const { t } = useNls()

  return (
    <MobileSheet
      open={open}
      onClose={onClose}
      title={t('NLSChatSheetAiTitle')}
      hint={channelName}
      ariaLabel={t('NLSChatSheetAiTitle')}
      testId="member-chat-ai-sheet"
      footer={onOpenAiMagic ? (
        <Button
          size="lg"
          variant="primary"
          className="w-full"
          icon={<AutoAwesomeRoundedIcon sx={{ fontSize: 16 }} />}
          onClick={() => { onOpenAiMagic(); onClose() }}
        >
          {t('NLSChatActionOpenAiMagic')}
        </Button>
      ) : null}
    >
      {summarySlot ? <div style={{ padding: '4px 0 8px' }}>{summarySlot}</div> : null}
      <ChatAiHistoryCard onOpenAiMagic={onOpenAiMagic} />
    </MobileSheet>
  )
}
